import { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import Navbar from '../components/common/NavBar';
import MiniHero from '../components/common/MiniHero';
import Footer from '../components/common/Footer';
import { get } from '../utils/api';
import { getUserLanguage } from '../utils/language';

const AchievementsGallery = () => {
  const [achievements, setAchievements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const language = getUserLanguage();

  const { ref: sectionRef, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  useEffect(() => {
    const fetchAchievements = async () => {
      try {
        const headers = { 'accept-language': language };
        const data = await get('/achievements', headers);
        setAchievements(data);
      } catch (error) {
        console.error('Error fetching achievements:', error);
        setError(language === 'cs' ? 'Nepodařilo se načíst úspěchy' : 'Failed to load achievements data');
      } finally {
        setLoading(false);
      }
    };
    fetchAchievements();
  }, [language]);

  if (loading) {
    return (
      <div className="min-h-screen bg-black">
        <Navbar language={language} />
        <MiniHero title={language === 'cs' ? 'Galerie úspěchů' : 'Achievements Gallery'} />
        <div className="flex justify-center py-20">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red"></div>
        </div>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-black">
        <Navbar language={language} />
        <MiniHero title={language === 'cs' ? 'Galerie úspěchů' : 'Achievements Gallery'} />
        <div className="text-white text-center py-20">{error}</div>
        <Footer />
      </div>
    );
  }

  const sortedAchievements = achievements.sort((a, b) => a.year - b.year);

  return (
    <div className="min-h-screen bg-black">
      <Navbar language={language} />
      <MiniHero title={language === 'cs' ? 'Galerie úspěchů' : 'Achievements Gallery'} />
      <section className="py-20 bg-black" ref={sectionRef}>
        <div className="container mx-auto px-4 sm:px-6">
          <div className="timeline-container">
            {sortedAchievements.map((achievement, index) => (
              <div
                key={achievement.id || index}
                className={`timeline-item ${inView ? 'animate-fade-in' : 'opacity-0'}`}
                style={{ animationDelay: `${0.2 * index}s` }}
              >
                <div className="timeline-year">{achievement.year || 'Není rok'}</div>
                <div className="timeline-card">
                  <h4 className="text-xl font-title font-bold text-white mb-2">
                    {achievement.title || (language === 'cs' ? 'Bez názvu' : 'No title')}
                  </h4>
                  <p className="text-gray-300">
                    {achievement.description || (language === 'cs' ? 'Bez popisu' : 'No description')}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default AchievementsGallery;